import React, { FC } from 'react';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
} from 'recharts';

const DEFAULT_NUM_OF_LOCATIONS = 10;
const CHART_HEIGHT = 400;
const CHART_HEIGHT_MOBILE = 300;

interface UserDistributionsBarChartProps {
  data: any[];
  indexBy: string;
  isMobile: boolean;
  keys: string[];
  tooltip?: any;
}

const COLORS = ['#8884d8', '#82ca9d', '#ffc658', '#ff7c7c', '#8dd1e1'];

const UserDistributionsBarChart: FC<UserDistributionsBarChartProps> = ({
  data,
  indexBy,
  isMobile,
  keys,
  tooltip,
}) => {
  const filteredData = data.slice(0, DEFAULT_NUM_OF_LOCATIONS);

  return (
    <div
      style={{
        width: '100%',
        height: isMobile ? CHART_HEIGHT_MOBILE : CHART_HEIGHT,
      }}
    >
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          data={filteredData}
          layout="vertical"
          margin={{
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis type="number" />
          <YAxis
            type="category"
            dataKey={indexBy}
            width={isMobile ? 90 : 140}
            tick={{ fontSize: isMobile ? 8 : 12 }}
          />
          <Tooltip 
            content={
              tooltip || 
              (({ active, payload, label }) => {
                if (active && payload && payload.length) {
                  return (
                    <div className="rounded-lg border border-black bg-black p-2 shadow-sm">
                      <div className="flex flex-col gap-1">
                        <span className="text-[0.70rem] uppercase text-gray-300">
                          {label}
                        </span>
                        {payload.map((entry: any, index: number) => (
                          <div key={index} className="flex items-center justify-between gap-2">
                            <span className="text-sm text-gray-300">
                              {entry.name || entry.dataKey}:
                            </span>
                            <span className="text-sm font-bold text-white">
                              {entry.value}
                            </span>
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                }
                return null;
              })
            } 
          />
          {keys.map((key, index) => (
            <Bar
              key={key}
              dataKey={key}
              stackId="stack"
              fill={COLORS[index % COLORS.length]}
            />
          ))}
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default UserDistributionsBarChart;
